import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper('.tags__slider', {
  slidesPerView: 'auto',
  spaceBetween: 10,
  freeMode: true,
  speed: 500,

  navigation: {
    nextEl: '.tags__next',
    prevEl: '.tags__prev',
  },

});
